import { type FC, memo, useEffect } from "react";
import { PageContent } from "@/components/PageContent/PageContent";
import { safeConsole } from "@/utils/safeConsole";
import { captureClientRouteError } from "@/utils/sentryRouteError";
import { ErrorInfo } from "./ErrorInfo";

type AuthenticatedErrorProps = {
  status?: number;
  error: Error;
};

export const AuthenticatedError: FC<AuthenticatedErrorProps> = memo(
  ({ error }) => {
    useEffect(() => {
      captureClientRouteError(error);
    }, [error]);

    safeConsole.log("error-boundary", error);
    return (
      <PageContent>
        <ErrorInfo
          title="Uh-oh!"
          subtitle="Something went wrong"
          description="We are working to fix this issue"
        />
      </PageContent>
    );
  },
);
